<a  class="sx-link-banner sxl-flex sxl-items-center" 
    href="javascript:void(0)" 
    (click)="navigate()" 
    [ngClass]="{'disabled': disabled}"
    [matTooltip]="matTooltipText">

    <div *ngIf="labelIcon" class="sx-link-banner__label-icon-container sxl-flex">
        <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
            <span class="sx-link-banner__label-icon">
                <svg>
                    <use [attr.xlink:href]="labelIcon" [attr.href]="labelIcon"/>
                </svg>
            </span>
        </div>
    </div>
    <div class="sx-link-banner__label" [ngClass]="{'sx-link-banner__label-no-padding': hasLabelIcon}">
        <ng-content></ng-content>
    </div>

    <div class="sx-link-banner__icon-container sxl-flex">
        <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
            <span class="sx-link-banner__icon">
                <svg>
                    <use [attr.xlink:href]="icon" [attr.href]="icon"/>
                </svg>
            </span>
        </div>
    </div>
</a>
